import * as t from 'io-ts';

export const PassengerDynamicType = t.interface({
    name: t.union([t.string, t.null]),
    nationality: t.union([t.string, t.null]),
    maskedPassportNumber: t.union([t.string, t.null]),
    maskedPassportExpiryDate: t.union([t.string, t.null]),
    maskedDateOfBirth: t.union([t.string, t.null]),
    order: t.number
});

export type Passenger = t.TypeOf<typeof PassengerDynamicType>;
